import configurl from '@/config/user.env';
import { importApi } from '@/modules/mdm/api/targetModdeules/monthRulesConfigurationSheet.js';
import { templateDownloadApi } from '@mdm/api/customer/customerPersonResponsibleImport';
export const importConfig = {
    action: configurl.apiUrl + 'api-lcrm/contractEnclosureInfo/upload',
    downloadApi: templateDownloadApi,
    importApi: importApi,
    downParams: {
        fileName: '月度目标拆解规则配置导入模板.xlsx',
        fileId: 'goalSplitRuleAddImport.xlsx'
    },
    multiple: false,
    accept: 'xlsx',
    downBtn: true,
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};
